import React, { ChangeEvent, useState } from 'react';
import { Controller } from 'react-hook-form';
import Modal from './modal/Modal';
import useImageSelector from './useImageSelector';
import ModalHeader from './modal/ModalHeader';
import Client from '../utils/network';
import Input from './UI/Input';
import Button from './UI/Button';


interface FormImageSelectProps {
    type: string,
    name: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rules: Record<string, any>,
}

const FormImageSelect = ({ type, name, rules }: FormImageSelectProps) => {
    const [isUploading, setIsUploading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    return (
        <Controller
            name={name}
            rules={rules}
            render={({ field: { onChange, value } }) => {

                const handleSelect = (id: string) => {
                    onChange(id);
                    setShowModal(false);
                };

                const handleDelete = async (id: string) => {
                    return Client.request(`/api/image/${id}/${type}`, {
                        method: 'DELETE',
                    }).then(() => {
                        resetImageSelector();
                        return;
                    }).catch(() => {
                        // do nothing
                    });
                };

                const {
                    resetImageSelector,
                    imageSelector,
                } = useImageSelector({
                    type,
                    onSelect: handleSelect,
                    onDelete: handleDelete,
                    className: 'flex gap-4 p-4 border-b border-slate-400 pretty-scroll',
                    imageClassName: 'w-20 h-20 mb-3',
                });

                const handleUpload = async (e: ChangeEvent<HTMLInputElement>) => {
                    setIsUploading(true);
                    if (!e.target.files || e.target.files.length === 0) {
                        return;
                    }
                    const formData = new FormData();
                    formData.append('file', e.target.files[0]);
                    const res: Response | void = await Client.request(`/api/image/${type}`, {
                        method: 'POST',
                        body: formData,
                    }).catch(() => {
                        return;
                    }).finally(() => {
                        setIsUploading(false);
                        resetImageSelector();
                    });

                    if (res) {
                        const image = await res.json() as { id: string };
                        onChange(image.id);
                        setShowModal(false);
                    }
                };

                return (
                    <>
                        <div>
                            {value && (
                                <img
                                    className="w-14 h-14 mb-2 mt-2"
                                    src={`${Client.getBaseUrl()}/api/image/${value as string}/thumbnail`}
                                />
                            )}
                            <Button className="mb-3" onClick={() => setShowModal(!showModal)}>Select image</Button>
                        </div>
                        <Modal show={showModal} toggle={() => setShowModal(!showModal)}>
                            <ModalHeader toggle={() => setShowModal(!showModal)}>
                                Select image
                            </ModalHeader>
                            {imageSelector}
                            <div
                                // eslint-disable-next-line max-len
                                className='pt-3 ps-2 pb-3 flex justify-center overflow-visible border-b border-slate-400'
                            >
                                <label
                                    htmlFor="files"
                                    // eslint-disable-next-line max-len
                                    className={`block  p-4 pt-3 pb-3 w-fit bg-mid-blue ${isUploading ? 'disabled' : ''}`}
                                >
                                    {isUploading
                                        ? 'Uploading new image'
                                        : 'Upload new image'}
                                    <Input
                                        disabled={isUploading}
                                        style={{ display: 'none' }}
                                        id='files' type="file" accept="image/*" onChange={handleUpload}
                                    />
                                </label>
                            </div>
                        </Modal>
                    </>
                );
            }}
        />
    );
};
export default FormImageSelect;
